import { render, staticRenderFns } from "./importantprojectManage.vue?vue&type=template&id=07f4965c&scoped=true"
import script from "./importantprojectManage.vue?vue&type=script&lang=js"
export * from "./importantprojectManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4965c",
  null
  
)

export default component.exports